export function calculatePageCount(itemCount, itemsPerPage) {
  return Math.ceil(itemCount / itemsPerPage);
}



// WEBPACK FOOTER //
// ./src/redux/modules/utils.js